import { render, staticRenderFns } from "./ServiceComments.vue?vue&type=template&id=9cb51f02&scoped=true"
import script from "./ServiceComments.vue?vue&type=script&lang=ts"
export * from "./ServiceComments.vue?vue&type=script&lang=ts"
import style0 from "./ServiceComments.vue?vue&type=style&index=0&id=9cb51f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb51f02",
  null
  
)

export default component.exports